import { Component } from "react";

export default class NotifBubble extends Component {
    render() {
        return this.props.value != 0 && <div className="notif-bubble d-flex align-items-center justify-content-center px-1">{this.props.value}</div>;
    }
}
